export default __webpack_public_path__ + "static/m-signbox-e4f5307380dc143147d6bf1cfa258583.png";